import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Location} from '@angular/common';
import {GeneralFormComponent} from '../../general/form/generalForm.component';
import {MessageService} from '../../../../shared/message.service';
import {QuestionService} from '../../../services/question.service';
import {GroupService} from '../../../services/group.service';
import {QuestionControlService} from '../../../services/question-control.service';
import {RegoVivoMappingService} from '../../../services/rego-vivo-mapping.service';
import {RegoVivoMapping} from '../../../interfaces/regoVivoMapping';


@Component({
  selector: 'app-regovivomapping-detail',
  templateUrl: '../../general/form/generalForm.component.html',
  styleUrls: ['../../general/form/generalForm.component.css']
})
export class RegoVivoMappingFormComponent extends GeneralFormComponent<RegoVivoMapping> implements OnInit {

  constructor(
    route: ActivatedRoute,
    location: Location,
    messagesService: MessageService,
    router: Router,
    questionService: QuestionService,
    userGroupService: GroupService,
    questionControlService: QuestionControlService,
    private regoVivoMappingService: RegoVivoMappingService
  ) {
    super(route, regoVivoMappingService, location, messagesService, router, questionService, questionControlService,
      {
        entityNameSingular: 'rego-vivo mapping',
        entityNamePlural: 'rego-vivo mappings',
        formUrl: 'regovivomapping',
        listUrl: 'regovivomappings',
        generalFormMetaName: 'rego-vivo-mapping'
      });
  }
}
